import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as ExcelIcon } from "../../assets/xsl-02.svg";
import { ReactComponent as PdfIcon } from "../../assets/pdf-02.svg";
import { ReactComponent as PrinterIcon } from "../../assets/printer.svg";
import { getUserCookie } from '../../hooks/authCookies';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import { useNavigate } from 'react-router-dom';

const Header = ({
  title,
  subtitle,
  i18n,
  haveBtn = false,
  btn,
  btnIcon,
  onSubmit,
  isExcel = false,
  isPdf = false,
  isPrinter = false,
  hasAddOrEditBtn=false,
  onExcel,
  onPdf,
  onPrinter,
  sub2,
  hasNavigate=false
}) => {
  const theme = useTheme();
  const isRtl = i18n.language === 'ar';
const user = getUserCookie();
const navigate = useNavigate();

const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box
      component="header"
      sx={{
        // direction: isRtl ? 'rtl' : 'ltr',
        display: 'flex',
        flexDirection: 'column',
        mb: 3,
        flexWrap: 'wrap',
      }}
    >
      <Typography  variant="h6" sx={{color: theme.palette.info.secondary, gap: 0.5,fontSize:14, display:"flex"}}>

        <Typography component={"span"} onClick={() => hasNavigate && navigate(-1)} sx={{cursor:"pointer"}}>
          {title}
        </Typography>
         
        { hasAddOrEditBtn && (isRtl ?
           <ArrowBackIosNewRoundedIcon sx={{ fontSize: 15 , fontWeight: 'bold', height:'20px' }} /> : <ArrowForwardIosRoundedIcon sx={{ fontSize: 16 , fontWeight: 'bold' , my:"auto" }} />) }
        {hasAddOrEditBtn &&
        <Typography component="span"  fontSize={13}  sx={{color: theme.palette.info.subtitle,my:0.5}}>
          {sub2}
        </Typography>
        }
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection:  isMobile ? 'column' : 'row',
          alignItems:  isMobile ? 'start' : 'center',
          justifyContent: 'space-between',
          gap: 2,
          my: 1,
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold',color: theme.palette.info.main, my:1 }}>
          {subtitle}
        </Typography>

        <Box display="flex" alignItems="center" gap={1.5} >
          {haveBtn && (
         <Button
         variant="contained"
         endIcon={btnIcon}
          //  endIcon={!isRtl && btnIcon  }
          // startIcon={isRtl && btnIcon  }
         onClick={onSubmit}
         sx={{
           direction: isRtl ?? "ltr",
           fontWeight: "bold",
          whiteSpace: "nowrap",
           bgcolor: "secondary.main",
           borderRadius: 1,
           "&:hover": {
             bgcolor: "secondary.dark", // keeps a visible hover state
           },
           gap:"10px"
         }}
     
       >
         {btn}
       </Button>       
          )}
{
 <>
          {isExcel && (
            <IconButton color="primary" onClick={onExcel} sx={{ p: 0.25 }}>
              <ExcelIcon width={25} height={25} />
            </IconButton>
          )}
          {isPdf && (
            <IconButton color="primary" onClick={onPdf} sx={{ p:  0.25 }}>
              <PdfIcon width={25} height={25} />
            </IconButton>
          )}
          {isPrinter && (
            <IconButton color="primary" onClick={onPrinter} sx={{ p:  0.25 }}>
              <PrinterIcon width={25} height={25} />
            </IconButton>
          )}
</>}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
